import type { Namespace, NamespaceFile, NamespaceFileUrl } from './types.js';

export const common: Namespace = import.meta.glob<NamespaceFile>(
    '../locales/*/common.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);
